import { Grid } from "@mui/material";
import React from "react";
import StockHeader from "./home/header";
import StockTable from "./home/table";

const Stock = () => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <StockHeader />
      </Grid>
      <Grid item xs={12}>
        <StockTable />
      </Grid>
    </Grid>
  );
};

export default Stock;
